/**
 * isProposalExpired — single source of truth for "has this HITL proposal's
 * server TTL lapsed?".
 *
 * The BE stamps every proposal with ``expires_at`` (24h TTL) and rejects
 * ``POST /actions/{id}/execute`` after it with "Proposta scaduta". The FE gates
 * the Accept/Conferma controls off THIS helper so a stale proposal (e.g. an old
 * conversation reopened a day later) can't be clicked into a 502 — the button
 * is disabled and an "expired, re-run" hint is shown instead.
 *
 * Proposals without ``expires_at`` (legacy frames, manually-created actions)
 * are treated as NEVER expired — we never block on missing data.
 */
export function isProposalExpired(expiresAt?: string | null): boolean {
  if (!expiresAt) return false;
  const ts = new Date(expiresAt).getTime();
  // Unparseable timestamp → don't block (fail-open, same as missing).
  return Number.isFinite(ts) && ts < Date.now();
}
